
import { Suspense } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import GalleryHero from './components/GalleryHero';
import GalleryStats from './components/GalleryStats';
import GalleryGrid from './components/GalleryGrid';
import GalleryCTA from './components/GalleryCTA';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';

/**
 * GalleryPage – main page for the image gallery.
 * Includes robust handling of environment variables and SEO configuration.
 */
export default function GalleryPage() {
  // Safely obtain the site URL; fallback to a placeholder if the env var is missing.
  const siteUrl = import.meta.env?.VITE_SITE_URL?.trim()
    ? import.meta.env.VITE_SITE_URL.trim()
    : 'https://example.com';

  // Apply SEO metadata – wrapped in a try/catch to avoid breaking the UI if the helper fails.
  try {
    useSEO({
      title:
        'Galerie Photos Véhicules & Services | Voyage Elite Chauffeur Privé Alpes',
      description:
        'Découvrez en images notre flotte Mercedes premium (Classe E, V, S), nos services VIP à bord et les destinations alpines desservies. Chauffeur privé Courchevel, Méribel, Val Thorens.',
      keywords:
        'galerie photos VTC Alpes, véhicules Mercedes premium, chauffeur privé Courchevel photos, transfert ski images, flotte luxe Alpes',
      canonical: '/galerie',
      schema: {
        '@context': 'https://schema.org',
        '@type': 'ImageGallery',
        '@id': `${siteUrl}/galerie#gallery`,
        url: `${siteUrl}/galerie`,
        name: 'Galerie Photos - Voyage Elite Chauffeur Privé Alpes',
        description:
          'Galerie photos de notre flotte Mercedes premium, services VIP et destinations alpines',
        inLanguage: 'fr-FR',
        breadcrumb: generateBreadcrumbSchema([
          { name: 'Accueil', url: '/' },
          { name: 'Galerie Photos', url: '/galerie' },
        ]),
        about: {
          '@type': 'Service',
          name: 'Service de Chauffeur Privé Premium',
          provider: {
            '@type': 'LocalBusiness',
            name: 'My Driver VTC Marseille',
            telephone: '+33605606006',
          },
        },
      },
    });
  } catch (err) {
    // Log the error for debugging; the page will still render.
    console.error('SEO configuration failed:', err);
  }

  return (
    <Suspense fallback={<div>Chargement...</div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <GalleryHero />
        <GalleryStats />
        <GalleryGrid />
        <GalleryCTA />
        <Footer />
      </div>
    </Suspense>
  );
}
